"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PanelCollapsible = _interopRequireDefault(require("../PanelCollapsible"));

var _Flex = _interopRequireDefault(require("../Flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var rowType = {
  total: {
    id: 0,
    label: 'Total'
  },
  validated: {
    id: 1,
    label: 'Validados'
  },
  pending: {
    id: 2,
    label: 'Pendientes'
  },
  rejected: {
    id: 3,
    label: 'Rechazados'
  }
};
var columnType = {
  1: 'Operadores',
  2: 'Vehículos',
  3: 'Remolques'
};

var Image = _styledComponents["default"].img.withConfig({
  displayName: "FleetSummaryTable__Image",
  componentId: "hb28of-0"
})(["width:30px;height:30px;border-radius:100%;margin:0 10px;"]);

var Typography = _styledComponents["default"].p.withConfig({
  displayName: "FleetSummaryTable__Typography",
  componentId: "hb28of-1"
})(["font-size:", ";color:", ";margin:0;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize.regular;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.white;
});

var _StyledTypography = (0, _styledComponents["default"])(Typography).withConfig({
  displayName: "FleetSummaryTable___StyledTypography",
  componentId: "hb28of-2"
})(["color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.primary;
});

var Cell = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "FleetSummaryTable__Cell",
  componentId: "hb28of-3"
})(["&:hover{", "{color:", ";text-decoration:underline;cursor:pointer;}}"], Typography, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.primary;
});

var _StyledCell2 = (0, _styledComponents["default"])(Cell).withConfig({
  displayName: "FleetSummaryTable___StyledCell2",
  componentId: "hb28of-4"
})(["", ";"], function (_ref5) {
  var name = _ref5.name,
      theme = _ref5.theme;
  return name === 'Total' ? "\n                          font-size: ".concat(theme.fontSize.large, ";\n                          height:50px;") : name === 'Pendientes' ? "\n                          >*{\n                          color: ".concat(theme.color.alert, ";}") : '';
});

var _StyledCell = (0, _styledComponents["default"])(Cell).withConfig({
  displayName: "FleetSummaryTable___StyledCell",
  componentId: "hb28of-5"
})(["color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.color.primary;
});

var _StyledPanelCollapsible = (0, _styledComponents["default"])(_PanelCollapsible["default"]).withConfig({
  displayName: "FleetSummaryTable___StyledPanelCollapsible",
  componentId: "hb28of-6"
})(["border-radius:10px;"]);

var _StyledFlex = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "FleetSummaryTable___StyledFlex",
  componentId: "hb28of-7"
})(["height:50px;"]);

var FleetSummaryTable = function FleetSummaryTable(_ref7) {
  var onCellClick = _ref7.onCellClick,
      companyId = _ref7.companyId,
      logo = _ref7.logo,
      name = _ref7.name,
      items = _ref7.items;

  var formatItems = function formatItems() {
    var itemsFormatted = Object.keys(columnType).reduce(function (previous, current) {
      return _objectSpread(_objectSpread({}, previous), {}, _defineProperty({}, current, {
        0: 0
      }));
    }, {});
    items.forEach(function (_ref8) {
      var statusId = _ref8.statusId,
          typeId = _ref8.typeId,
          quantity = _ref8.quantity;
      itemsFormatted[typeId][0] += quantity;
      itemsFormatted[typeId][statusId] = quantity;
    });
    return itemsFormatted;
  };

  var itemsByColumn = formatItems();
  return /*#__PURE__*/_react["default"].createElement(_StyledPanelCollapsible, {
    maxExpandedHeight: "250px"
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_StyledFlex, {
    col: "auto",
    container: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(Image, {
    src: logo
  }), /*#__PURE__*/_react["default"].createElement(_StyledTypography, null, name)), Object.keys(columnType).map(function (columnId) {
    return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
      key: columnId
    }, /*#__PURE__*/_react["default"].createElement(_StyledCell, {
      container: true,
      center: true
    }, columnType[columnId]));
  })), Object.keys(columnType).map(function (typeId) {
    typeId = Number(typeId);
    var cellInfo = itemsByColumn[typeId];
    return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
      container: true,
      direction: "column",
      key: typeId,
      col: "auto"
    }, Object.keys(rowType).map(function (key) {
      var statusId = rowType[key].id;
      var name = rowType[key].label;
      var cellStatus = cellInfo[statusId];
      return /*#__PURE__*/_react["default"].createElement(_StyledCell2, {
        key: "".concat(name, "-").concat(statusId),
        container: true,
        center: true,
        name: name,
        onClick: function onClick() {
          return onCellClick(statusId, typeId, companyId);
        }
      }, /*#__PURE__*/_react["default"].createElement(Typography, null, cellStatus || 0));
    }));
  })));
};

FleetSummaryTable.propTypes = {
  /** Nombre de la función a ejecutar en click. */
  onCellClick: _propTypes["default"].func,

  /** Identificador de la empresa. */
  companyId: _propTypes["default"].number,

  /** URL de la imagen a mostrar en  */
  logo: _propTypes["default"].string,

  /** Nombre para mostrar en */
  name: _propTypes["default"].string,

  /** Items to show on each column */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /**  Corresponde al encabezado de fila */
    statusId: _propTypes["default"].number,

    /** Corresponde a la columna */
    typeId: _propTypes["default"].number,

    /** valor a mostrar. */
    quantity: _propTypes["default"].number
  }))
};
var _default = FleetSummaryTable;
exports["default"] = _default;